module.exports = __webpack_public_path__ + "img/center-details-data2.8c02d874.png";